module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_7016.a60ed782.png";